import { Formik, FormikProps, Form as FormikForm, Field } from 'formik'
import { ContentNote } from 'globalTypes'

import { useMutation } from '@apollo/client'
import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/App/Form/Button'
import Textarea from 'Root/App/Form/Textarea'
import Title from 'Root/App/Title'

import { submit } from './form'
import MUTATION from './update-content-note.graphql'

interface Props {
  id: string
  content: ContentNote
}

const Form = ({ content, id }: Props) => {
  const { i18n } = useLingui()
  const [mutate] = useMutation(MUTATION)

  const initialValues = {
    note: content?.content?.note || '',
  }

  return (
    <Formik initialValues={initialValues} onSubmit={submit(mutate, id, i18n)}>
      {(formikProps: FormikProps<any>) => (
        <FormikForm className="mx-auto px-4 py-6 max-w-7xl text-gray-800 sm:px-6 flex flex-col gap-5 my-6">
          <Title size="S">
            <Trans>Appunti personali</Trans>
          </Title>
          <Field as={Textarea} id="note" name="note" />
          <Button
            disabled={!formikProps.isValid || !formikProps.dirty}
            type="submit"
            processing={formikProps.isSubmitting}
          >
            <Trans>Salva</Trans>
          </Button>
        </FormikForm>
      )}
    </Formik>
  )
}

export default Form
